export default __webpack_public_path__ + "static/media/modern-logo-on-light.96bbbcfa.svg";